import { createApi } from '@reduxjs/toolkit/query/react';

import { IPlanHistory } from '../store/planHistory.slice';

import { baseQueryWithReauth } from './api';

export const planHistoryApi = createApi({
  reducerPath: 'planHistory',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['planHistory'],
  endpoints: (build) => ({
    getTransactions: build.query<IPlanHistory[], void>({
      query: () => ({
        url: '/me/transactions',
      }),
    }),
  }),
});

export const { useLazyGetTransactionsQuery } = planHistoryApi;
